// https://developer.voyado.com/en/web-activity-tracking.html

import type { Cart } from "@server/gql/graphql";

import type { MarketConfiguration } from "@/config/markets/const";
import type { Variant } from "types";
import { parseJwt } from "./parseJwt";

declare global {
  interface Window {
    va: any;
  }
}

export function sendVoyadoEmptyCartEvent(id?: string) {
  if (window.va === undefined || !id) {
    return;
  }

  window.va("emptyCart", {
    cartRef: id,
  });
}

export function sendVoyadoCartChangeEvent({
  market,
  cart,
}: {
  market: MarketConfiguration;
  cart?: Cart | null;
}) {
  if (window.va === undefined || !cart) {
    return;
  }

  const items = cart.items.map((cartItem) => ({
    itemId: cartItem.partNo,
    quantity: cartItem.quantity,
  }));

  window.va("cart", {
    cartRef: cart.id,
    locale: market.contentfulLocale,
    items,
  });
}

export function setVoyadoContactId(token: string) {
  try {
    const parsedToken = parseJwt(token);
    const voyadoContactId = parsedToken["ng.voyadoid"];

    if (voyadoContactId) {
      window.va("setContactId", voyadoContactId);
    }
  } catch (error) {
    console.warn("Failed to set Voyado Contact ID: ", error);
  }
}

export function sendVoyadoProductViewEvent({
  market,
  item,
}: {
  market: MarketConfiguration;
  item: Variant;
}) {
  try {
    if (window.va === undefined) {
      return;
    }

    const categoryName = item.category.join(" / ");

    window.va("productview", {
      categoryName,
      itemId: item.id,
      locale: market.contentfulLocale,
    });
  } catch (error) {
    console.warn("Failed to send Voyado product view event: ", error);
  }
}

export function sendVoyadoEmailRegistrationEvent(email: string) {
  if (window.va === undefined) {
    return;
  }

  try {
    window.va("emailRegistration", {
      email,
    });
  } catch (error) {
    console.warn("Failed to send Voyado email registration event: ", error);
  }
}
